import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BASE_URL from '../config/config';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import SelectorIdioma from '../components/ui/SelectorIdioma';

const RecuperarContrasena = () => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [disabled, setDisabled] = useState(false); // Estado para manejar el cooldown del botón
  const [cooldown, setCooldown] = useState(0); // Estado para la cuenta atrás

  const handleEmailChange = (event) => {
    setEmail(event.target.value.toLowerCase());
  };

  const handleSubmit = async () => {
    if (disabled) return; // Si el botón está deshabilitado, no hace nada

    setEnviando(true);
    setCooldown(30); // Establecer el cooldown inicial a 30 segundos
    try {
      const response = await axios.post(`${BASE_URL}/recuperar-contrasena`, { email, idioma: i18n.language });

      if (response.status === 200) {
        setMessage(t('recuperar.enviado'));
        setError('');
        setDisabled(true); // Deshabilitar el botón
      } else {
        setError(response.data.message || t('recuperar.errorEnvio'));
        setMessage('');
      }
    } catch (error) {
      console.error('Error al recuperar la contraseña:', error);
      setError(t('recuperar.errorGenerico'));
      setMessage('');
    } finally {
      setEnviando(false);
    }
  };

  // Manejar la cuenta atrás
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setTimeout(() => {
        setCooldown((prev) => prev - 1);
      }, 1000); // Reducir el contador cada segundo
    } else if (cooldown === 0 && disabled) {
      setDisabled(false); // Reactivar el botón cuando el cooldown llegue a 0
    }
    return () => clearTimeout(timer); // Limpiar el timer al desmontar el componente o al cambiar el estado
  }, [cooldown, disabled]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !disabled) {
      handleSubmit();
    }
  };

  return (
    <main className="inicia-sesion">
      <div className="bg-intro-blob bg-intro-blob-1"></div>
      <div className="inicio-idioma"><SelectorIdioma /></div>
      <Link to="/" className="volver-inicio"><FiArrowLeft /> {t('comun.volverInicio')}</Link>
      <div className="formulario-inicio">
        <div className="logo-form-inicio">
          <img src="/images/logoadhoc.svg" alt={t('comun.marcaLogo')} />
          <p className="p-soporte">v3.2</p>
        </div>
        <h1>{t('recuperar.titulo')}</h1>
        <p>{t('recuperar.texto')}</p>
        <div className="campos-inicio">
          <div className="campo-inicio">
            <label htmlFor="email">{t('recuperar.correo')}</label>
            <div className="campo-inicio-input">
              <FiMail className="campo-inicio-icon" />
              <input
                autoComplete="off"
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                onKeyDown={handleKeyDown}
                placeholder={t('recuperar.placeholderCorreo')}
              />
            </div>
          </div>
          {message && <p className="success">{message}</p>}
          {error && <p className="error">{error}</p>}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={disabled} // Deshabilitar el botón cuando esté en cooldown
          >
            {disabled
              ? t('recuperar.esperar', { segundos: cooldown })
              : (enviando ? t('recuperar.enviando') : t('recuperar.enviar'))}
          </button>
        </div>
      </div>
    </main>
  );
};

export default RecuperarContrasena;
